import axios from '@/api/axiosInstance';
import type { SurveyTag, Survey } from '@/v2/domains/Surveys/types/survey';

type Params = {
  count?: number;
  tags: SurveyTag[];
};

export type GetUnansweredSurveysResponse = {
  unansweredSurveys: Survey[];
  answeredSurveysCount: number;
};

export default async function getUnansweredSurveys({
  count = 1,
  tags,
}: Params): Promise<GetUnansweredSurveysResponse> {
  const response = await axios({
    url: `${process.env.NEXT_PUBLIC_API}/teacher/surveys`,
    method: 'get',
    params: {
      count,
      tags: tags.join(','),
    },
  });

  return response.data;
}
